module.exports = __webpack_public_path__ + "static/media/blue_face_snafu.bccc679b.PNG";